/** @jsx isolateComponent */

import { FlexLayout } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Button, Spacer, Text } from '@zapier/design-system';

import { useSize } from '@zapier/promotions/src/hooks';

import { Confetti } from './Confetti';

type Props = {
  planName: string;
};

export const OfferAcceptedView = ({ planName }: Props) => {
  const size = useSize();

  return (
    <FlexLayout align="center" direction="column" wrap="no-wrap">
      <Confetti />

      <Text tag="h1" type="header700">
        Thanks for upgrading!
      </Text>

      <Text tag="p" textAlign="center" type="bodyText900">
        You're now on the {planName} plan.
      </Text>

      <Spacer height={20} />

      <FlexLayout
        direction={size === 'small' ? 'column' : 'row'}
        justify="center"
      >
        <Button
          hasShadow={true}
          href="/app/dashboard"
          isFullWidth={size === 'small'}
        >
          Go to dashboard
        </Button>
      </FlexLayout>
    </FlexLayout>
  );
};
